// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/icon/iconfont.css
// module id = 876
// module chunks = 41